<div class="padding-content orders-page" *ngIf="idEvent">
    <!-- Selector de vista: lista de pedidos / mapa de butacas -->
    <div class="view-toggle">
        <button type="button" class="toggle-btn" [class.active]="view === 'list'"
            (click)="view = 'list'">
            <i class="fa-regular fa-list"></i>
            <span>Lista</span>
        </button>
        <button type="button" class="toggle-btn" [class.active]="view === 'map'"
            (click)="view = 'map'">
            <i class="fa-regular fa-chart-tree-map"></i>
            <span>Mapa</span>
        </button>
    </div>

    <div class="content-table-orders" [hidden]="view !== 'list'">
        <app-orders-list [idEvent]="idEvent"></app-orders-list>
    </div>

    <div class="content-map-orders" *ngIf="view === 'map'">
        <app-event-orders-map [idEvent]="idEvent"></app-event-orders-map>
    </div>
</div>
